import hexRgba from 'hex-rgba';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { color } from '../../../app/theme';

function IconXCircleBlack({ className, width, height, id, viewBox, onClick }) {
  const [isHover, setIsHover] = useState(false);

  return (
    <svg
      id={id}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={onClick}
    >
      <defs>
        <path
          id="a"
          d="M14.786 13.786a.69.69 0 0 1 0 1 .648.648 0 0 1-.5.214.648.648 0 0 1-.5-.214L10 11l-3.786 3.786a.648.648 0 0 1-.5.214.648.648 0 0 1-.5-.214.69.69 0 0 1 0-1L9 10 5.214 6.214a.69.69 0 0 1 0-1 .69.69 0 0 1 1 0L10 9l3.786-3.786a.69.69 0 0 1 1 0 .69.69 0 0 1 0 1L11 10l3.786 3.786z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle
          cx="12"
          cy="12"
          r="12"
          fill={isHover ? hexRgba(color.$10, 40) : color.$10}
          fillRule="nonzero"
        />
        <g transform="translate(2 2)">
          <path d="M0 0h20v20H0z" />
          <mask id="b" fill={color.$7}>
            <use xlinkHref="#a" />
          </mask>
          <g fill={color.$7} mask="url(#b)">
            <path d="M0 0h20v20H0z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

IconXCircleBlack.defaultProps = {
  className: undefined,
  width: 16,
  height: 16,

  viewBox: '0,0,24,24',
};

IconXCircleBlack.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  viewBox: PropTypes.string,
};

export default IconXCircleBlack;
